
import StepBar from "@/components/stepBar/StepBar.vue";
import Error from "@/components/modal/Error.vue";
import { MutationTypes } from "@/store/modules/auth";
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    StepBar,
    Error,
  },
  data() {
    return {
      firstName: null,
      lastName: null,
      email: null,
      phoneNumber: null,
      password: null,
      confirmPassword: null,
      username: null,
      birthDate: "",
      sex: null,
      address: null,
      city: null,
      zipCode: null,
      country: null,
      duplicatePseudo: false,
      showErrorModal: false,
    };
  },
  methods: {
    toggleErrorModal() {
      this.showErrorModal = !this.showErrorModal;
    },
    dateIsCorrect() {
      const date = new Date(this.birthDate);
      if (this.birthDate === "") return true;
      if (isNaN(date.getTime())) return false;
      if (date < new Date()) return true;
      else return false;
    },
    async register() {
      const response = await axios.post("athletes", {
        firstName: this.firstName,
        lastName: this.lastName,
        address: this.address,
        zipCode: this.zipCode,
        city: this.city,
        country: this.country,
        phoneNumber: this.phoneNumber,
        email: this.email,
        username: this.username,
        password: this.password,
        dateOfBirth: this.birthDate,
        sex: this.sex == 1 ? true : false,
      });

      if (
        response.status === 409 &&
        response.data.message === "EMAIL_ALREADY_EXISTS"
      ) {
        alert(
          "L'utilisateur existe déjà, redirection vers la page de connexion"
        );
        this.$router.push({ name: "Login" });
      }
      if (
        response.status === 409 &&
        response.data.message === "USERNAME_ALREADY_EXISTS"
      ) {
        this.duplicatePseudo = true;
      }

      if (response.status === 400) {
        this.toggleErrorModal();
      }

      if (response.status < 300) {
        const response = await axios.post("login", {
          email: this.email,
          password: this.password,
          username: this.username,
        });

        if (response.status === 200) {
          this.$store.commit(
            `auth/${MutationTypes.SET_ACCESS_TOKEN}`,
            response.data.accessToken
          );
          this.$store.commit(
            `auth/${MutationTypes.SET_REFRESH_TOKEN}`,
            response.data.refreshToken
          );
          const base64Url =
            this.$store.getters["auth/getAccessToken"].split(".")[1];
          const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
          const jsonPayload = decodeURIComponent(
            atob(base64)
              .split("")
              .map(function (c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
              })
              .join("")
          );
          this.$store.commit(
            `auth/${MutationTypes.SET_USER}`,
            JSON.parse(jsonPayload).id
          );
          this.$store.commit(
            `auth/${MutationTypes.SET_ATHLETE_ID}`,
            JSON.parse(jsonPayload).athleteId
          );
          this.$store.dispatch("user/setMe");
          this.$router.push({ name: "RegisterTeam" });
        }
      }
    },
  },
  watch: {
    username(oldName, newName) {
      this.duplicatePseudo = false;
    },
  },
  mounted() {
    if (!this.$store.getters["edition/isRegistrationOpen"]) {
      alert("Désolé, mais il est trop tôt/tard pour s'inscrire");
      return this.$router.push({ name: "Home" });
    }
  },
});
